import { loadStripe, Stripe } from '@stripe/stripe-js';

const stripePromises: Map<string, Promise<Stripe | null>> = new Map();

export function getStripeInstance(stripeAccountId: string): Promise<Stripe | null> {
	if (!stripeAccountId) {
		return Promise.resolve(null);
	}
	const existing = stripePromises.get(stripeAccountId);
	if (existing) {
		return existing;
	}
	const publishableKey = process.env.NEXT_PUBLIC_BUILD_STRIPE_PUBLISHABLE_KEY || '';
	const promise = loadStripe(publishableKey, { stripeAccount: stripeAccountId });
	stripePromises.set(stripeAccountId, promise);
	return promise;
}
